<template>
  <div id="summary-payment">
    <h3>Order summary</h3>
    <table class="table table-responsive xm-order-table">
      <tr class="faded">
        <th>Item</th>
        <th>Price</th>
      </tr>

      <tr v-for="cart_item in getFullCart" :class="isPromo(cart_item) ? 'text-success' : ''">
        <td>
          <span v-if="cart_item.provider.name === 'xmission'">
            {{ cart_item.description }} <span v-if="cart_item.quantity > 1">(x{{ cart_item.quantity }})</span>
            <span v-if="cart_item.rate_mode === 'variable' && cart_item.rate >= cart_item.rate_max">
              <br/>
              <small>Up to ${{ cart_item.rate_max }} value</small>
            </span>
          </span>
          <span v-else>
            <b>{{ rateString(cart_item.rate, cart_item.quantity, cart_item.rate_type, cart_item.rate_period, cart_item.rate_term, cart_item.rate_mode) }}</b>{{ ratePeriodString(cart_item.rate_period, cart_item.rate_term, cart_item.description) }} <small>{{ taxString(cart_item.rate, cart_item.taxable) }}</small>
          </span>
        </td>

        <td>
          <span v-if="cart_item.provider.name === 'xmission'">
            <b>{{ rateString(cart_item.rate, cart_item.quantity, cart_item.rate_type, cart_item.rate_period, cart_item.rate_term, cart_item.rate_mode) }}</b>{{ ratePeriodString(cart_item.rate_period, cart_item.rate_term, '') }} <small>{{ taxString(cart_item.rate, cart_item.taxable) }}</small>
          </span>
          <span v-else>
            <small>billed separately <br/> by {{ cart_item.provider.label }}</small>
          </span>
        </td>

      </tr>
      <tr class="total-row">
        <td><b>Due today</b></td>
        <td><b>${{ oneTimeXmissionTotalDueNow['total'] }}</b> <small>{{ taxString(oneTimeXmissionTotalDueNow['total'], oneTimeXmissionTotalDueNow['taxed']) }}</small></td>
      </tr>
      <tr style="background-color:#f5f5f5">
        <td><b>Total </b>due XMission <br />upon installation and activation<br /></td>
        <td><b>${{ oneTimeXmissionTotalDueLater['total'] }}</b> <small>{{ taxString(oneTimeXmissionTotalDueLater['total'], oneTimeXmissionTotalDueLater['taxed']) }}</small></td>
      </tr>
      <tr v-for="[ndx, total_details] of monthlyTotalsAfterFirstMonth.entries()" :key="ndx">
        <td><b>Total </b>due XMission <small>{{ dueTermString(ndx + 1) }}</small></td>
        <td><b>{{ rateString(total_details['total'], 1, 'price') }}</b>{{ ratePeriodString((total_details['rate_term'] !== 1) ? 'monthly' : 'one-time', total_details['rate_term'], '', true) }} <small>{{ taxString(total_details['total'], total_details['taxed']) }}</small></td>
      </tr>
    </table>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';
  import logger from "../../lib/logger";
  export default {
    computed: {
      ...mapGetters([
        'getFullCart',
        'oneTimeXmissionTotalDueNow',
        'oneTimeXmissionTotalDueLater',
        'monthlyXmissionTotals',
      ]),
      monthlyTotalsAfterFirstMonth () {
        return this.monthlyXmissionTotals.filter(x => x.rate_term !== 1);
      },
      monthlyTotalGroupChangeIndex () {
        logger.debug('monthlyXmissionTotals', this.monthlyXmissionTotals);
        for (let [ndx, item] of this.monthlyXmissionTotals.entries()){
          if (item.rate_term === null) {
            continue;
          }
          if (item.rate_term > ndx + 1) {
            return ndx;
          }
        }
        return null;
      }
    },

    methods: {
      isPromo(cart_item){
        return cart_item.rate_type === 'promo';
      },
      rateString(rate, quantity, rate_type, rate_period = null, rate_term = null, rate_mode = 'fixed') {
        // some promos apply over a period. but we want to show it in the summary as a one-time credit of rate_max value
        if (rate_type === 'promo' && rate_period === 'monthly' && rate_term !== null && rate_mode === 'variable') {
          rate = rate * rate_term;
        }
        rate = rate * quantity;
        let rate_string = `$${rate}`;
        if (rate_type === 'promo') {
          return `-${rate_string}`;
        }
        return rate_string;
      },
      ratePeriodString(rate_period, rate_term, description, is_a_total=false) {
        let rate_period_string = is_a_total ? '' : ' one-time';
        if (rate_period === 'monthly' && rate_term !== 1) {
          rate_period_string = '/month';
        }
        if (description) {
          rate_period_string += ` ${description}`;
        }
        return rate_period_string;
      },
      taxString(rate, taxable) {
        if (taxable && rate > 0) {
          return `+ tax`;
        }
        return '';
      },

      monthsString(rate_term) {
        // probably won't be used much past 12 months so we'll just hardcode it for now
        // let rate_term_map = {1: 'first', 2: 'second', 3: 'third', 4: 'fourth', 5: 'fifth', 6: 'sixth', 7: 'seventh',
        //                      8: 'eighth', 9: 'ninth', 10: 'tenth', 11: 'eleventh', 12: 'twelfth'};
        let rate_term_map = {1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five', 6: 'six', 7: 'seven',
                             8: 'eight', 9: 'nine', 10: 'ten', 11: 'eleven', 12: 'twelve'};
        if (rate_term === 1) {
          return 'one month';
        }
        return `${rate_term_map[rate_term]} months`;
      },

      dueTermString(total_details_index) {
        let total_details = this.monthlyXmissionTotals[total_details_index];
        let is_final_month = total_details_index === this.monthlyXmissionTotals.length - 1;
        // if the rate term is > the index (1-based indexing), then that means there is something like 6 months of
        // the same rate, then after that six months there is some other rate. So instead of saying first month, second month, etc
        // we'll say "next n months" and then "after the last" for the last one.
        if (!is_final_month) {
          if ((total_details['rate_term'] > total_details_index + 1) || (this.monthlyTotalGroupChangeIndex !== null && this.monthlyTotalGroupChangeIndex <= total_details_index)){
            return `after ${this.monthsString(this.monthlyXmissionTotals[total_details_index - 1]['rate_term'])}`;
          }
          else {
            return `for ${this.monthsString(this.monthlyXmissionTotals[total_details_index]['rate_term'])}`;
          }
        }
        return `after ${this.monthsString(this.monthlyXmissionTotals[total_details_index - 1]['rate_term'])}`;
      }

    }
  }
</script>


<style scoped>
  .xm-order-table {width:auto !important; margin-bottom:0 !important;}

  .xm-order-table, .xm-order-table th, .xm-order-table td {border:0 transparent !important}

  .xm-order-table th {
    font-size:12px; font-weight:normal;
    padding-bottom:0 !important;
  }

  .xm-order-table td:not(:last-child) {
    padding-right:36px !important;
  }

  .faded {opacity:0.7}

  .xm-order-table .total-row {
    border-top:1px solid #aaa;
    padding-top:4px !important;
  }
</style>



// WEBPACK FOOTER //
// OrderSummary.vue?6a738550